module.exports = __webpack_public_path__ + "img/file.9e15da3.jpg";